/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons/index.js";
import { colors } from "../../../constants/colors.js";

/* Styles */
import styles from "./styles.js"


const Footer = props => {
  const { setShowModal, handleSaveModal, saveButtonText, spinnerName } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <ContainerFluid className="gx-0">
      <div className={classes.btnContainer}>
        <UCButton
          type="default"
          className={classes.saveBtn}
          text={<FormattedMessage id="primaryModal.cancel"/>}
          onClick={() => setShowModal(false)}
        />
        <UCButton
          type="primary"
          className={classes.saveBtn}
          text={saveButtonText}
          onClick={handleSaveModal}
          spinner={{
            name: spinnerName,
            size: 20,
            color: colors.white
          }}
        />
      </div>
    </ContainerFluid>
  )
}

export default Footer;
